import angular from 'angular';
import common from './core.module';
import { PlayersList } from '@alquilatucancha/backoffice-integration';
import {
    PlayersHistoryService,
    PlayersHistoryController,
    BookingCompressedDirective,
    StatQualifierDirective
} from './services/PlayersHistory.service';

// import {
//     PlayersOfflineService,
//     PlayersOfflineController,
// } from './services/PlayersOffline.service';

const moduleName = 'atc-players';

angular.module(moduleName, [common])
    .service('PlayersHistory', PlayersHistoryService)
    // .service('PlayersOffline', PlayersOfflineService)
    .controller('PlayersHistoryController', PlayersHistoryController)
    // .controller('PlayersOfflineController', PlayersOfflineController)
    .directive('atcBookingCompressed', BookingCompressedDirective)
    .directive('statQualifier', StatQualifierDirective)
    .directive('playersV3List', [
        'Backoffice',
        'PlayersHistory',
        (Backoffice, PlayersHistory) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], PlayersList, {
                    onPlayerHistory: ({ id, name }) =>
                        PlayersHistory.open(
                            { id, name },
                            false, // online
                            false, // tab_owes
                            true, // from_backoffice (para zIndex correcto)
                        ),
                });

                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('playersV3Selector', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            scope: {
                onPlayerSelect: '&',
            },
            link: (scope, el) => {
                Backoffice.renderComponent(el[0], PlayersList, {
                    mode: 'selector',
                    onPlayerSelect: (player) =>
                        scope.$applyAsync(() =>
                            scope.onPlayerSelect({ $player: player }),
                        ),
                });

                scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
;


export default moduleName;
